export function shouldWarnForDefaultNote({
  note,
  templateNote,
  noteLocked,
  acknowledged,
}: {
  note: string;
  templateNote: string;
  noteLocked: boolean;
  acknowledged: boolean;
}) {
  const normalized = (value: string) => value.trim().replace(/\s+/g, " ");
  return (
    !noteLocked &&
    Boolean(normalized(templateNote)) &&
    normalized(note) === normalized(templateNote) &&
    !acknowledged
  );
}
